import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import Button from 'js/components/shared/Button';
import {setPressHandlers} from 'js/helpers/utils';
import {searchBox} from '../../../../drupalSettings';

import styles from './Suggestions.module.scss'

const cx = classnames.bind(styles);
const { clear } = searchBox?.titles || {};

const Suggestions = function ({
  className,
  data,
  title,
  titleIcon,
  itemsIcon,
  onClick,
  onClear,
}) {
  const onSuggestionClick = function (e, data) {
    e.preventDefault();
    e.stopPropagation();
    onClick(data);
  }

  const onClearClick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    onClear && onClear();
  }

  const onImageLoadError = function (e) {
    e.target.style.visibility = 'hidden';
  }

  return (
    <div className={cx('root', className)}>
      {title && (<div className={cx('section-header')}>
        {titleIcon && (<i className={cx('section-icon', `icon-${titleIcon}`)}/>)}
        <h4 className={cx('section-title')}>{title}</h4>
        {onClear && (
          <Button
            theme="link"
            className={cx('clear')}
            onClick={onClearClick}
          >
            {clear}
          </Button>
        )}
      </div>)}
      <ul className={cx('suggestions')}>
        {data?.map((el, i) => (
          <li
            key={i}
            className={cx('suggestion')}
            {...setPressHandlers((e) => onSuggestionClick(e, el))}
          >
            {!el.icon && (<i className={cx('item-icon', `icon-${itemsIcon}`)}/>)}
            {el.icon && (<img width="20" height="20" src={el.icon} alt={el.name} className={cx('item-image')} onError={onImageLoadError}/>)}
            <span className={cx('title')}>{el.name}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

Suggestions.propTypes = {
  className: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
  })).isRequired,
  title: PropTypes.string,
  titleIcon: PropTypes.string,
  itemsIcon: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onClear: PropTypes.func,
}

export default Suggestions;
